<template>
	<div class="flex flex-col items-center justify-center pt-2">
		<div class="w-full">
			<div class="mb-6 mt-2 w-full border-b border-dark dark:border-light">
				<SheetHeader class="mb-4">
					<SheetTitle>Results</SheetTitle>
					<SheetDescription class="sr-only">Results from the selected node</SheetDescription>
				</SheetHeader>
			</div>
			<div class="flex w-full flex-wrap gap-2">
				<div key="outcome_exit" class="mb-2 w-full flex-grow px-2 md:mb-5">
					<div class="formGroup flex flex-col">
						<label class="text-grey truncate" for="outcome_exit">Exit</label>
						<p class="form-control">{{ outcomeData.exit }}</p>
					</div>
				</div>
				<div v-for="(data, index) in outcomeData.data" :key="index" class="mb-2 w-full flex-grow px-2 md:mb-5">
					<div class="formGroup flex flex-col">
						<label class="text-grey truncate" :for="'outcome_data_' + index">{{ data.name }}</label>
						<p v-if="data.type === 'number'" class="form-control text-blue-500 dark:text-blue-300">
							{{ data.value }}
						</p>
						<p
							v-else-if="data.type === 'text' || data.type === 'string'"
							class="form-control text-gray-700 dark:text-gray-300"
						>
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'email'" class="form-control text-green-500 dark:text-green-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'tel'" class="form-control text-purple-500 dark:text-purple-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'url'" class="form-control text-blue-700 dark:text-blue-400">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'textarea'" class="form-control text-gray-700 dark:text-gray-300">
							{{ data.value }}
						</p>
						<p
							v-else-if="data.type === 'color'"
							class="form-control"
							:style="{ backgroundColor: data.value }"
						>
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'date'" class="form-control text-orange-500 dark:text-orange-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'time'" class="form-control text-pink-500 dark:text-pink-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'range'" class="form-control text-yellow-500 dark:text-yellow-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'radio'" class="form-control text-indigo-500 dark:text-indigo-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'password'" class="form-control text-red-500 dark:text-red-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'select'" class="form-control text-teal-500 dark:text-teal-300">
							{{ data.value }}
						</p>
						<p v-else-if="data.type === 'checkbox'" class="form-control text-gray-700 dark:text-gray-300">
							{{ data.value ? 'Yes' : 'No' }}
						</p>
						<p v-else-if="data.type === 'file'" class="form-control text-gray-700 dark:text-gray-300">
							{{ data.value }}
						</p>
						<div v-else-if="data.type === 'multi'" class="flex flex-col gap-1">
							<div v-for="(option, idx) in data.value" :key="idx" class="flex w-full items-center gap-2">
								<p class="form-control w-full text-gray-700 dark:text-gray-300">{{ option }}</p>
							</div>
						</div>
						<p v-else-if="data.type === 'flow'" class="form-control text-gray-700 dark:text-gray-300">
							{{ data.value }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<SheetFooter class="flex flex-row gap-2">
			<SheetClose as-child>
				<Button class="bg-red-500 hover:bg-destructive" @click.stop="$emit('close')">Close</Button>
			</SheetClose>
		</SheetFooter>
	</div>
</template>

<script>
import { SheetClose, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/nodesheet'
import { Button } from '@/components/ui/button'

export default {
	components: {
		Button,
		SheetClose,
		SheetDescription,
		SheetFooter,
		SheetHeader,
		SheetTitle
	},
	inject: ['user', 'userRoles', 'tenants'],
	props: ['outcome', 'closeHandler', 'selectedTenantId', 'selectedAccountId', 'readonly'],
	data() {
		return {
			outcomeData: this.outcome ? this.outcome : {}
		}
	}
}
</script>
